import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import {
  getCollectionPointBilling,
  getCollectionPointBillingAnnualPayment,
  getCollectionPointBillingPaymentSchedule,
  getCollectionPointBillingQuarterlyPayments,
  getCollectionPointBillingRefunds,
  getCollectionPointBillingStatus,
} from "../../../../selectors/collectionPoint";
import { BillingStatus } from "../../../../types/billings";
import { BillingPaymentAnnualCard } from "../BillingPaymentAnnualCard";
import { BillingPaymentQuarterCard } from "../BillingPaymentQuarterCard/BillingPaymentQuarterCard";
import { BillingRefundCard } from "../BillingRefundCard";

import styles from "./BillingPayments.module.scss";

export const BillingPayments = () => {
  const { t } = useTranslation();
  const billing = useSelector(getCollectionPointBilling);
  const paymentSchedule = useSelector(getCollectionPointBillingPaymentSchedule);
  const billingStatus = useSelector(getCollectionPointBillingStatus);
  const yearlyPayment = useSelector(getCollectionPointBillingAnnualPayment);
  const quarterlyPayments = useSelector(getCollectionPointBillingQuarterlyPayments);
  const refunds = useSelector(getCollectionPointBillingRefunds);

  if (billing === null || paymentSchedule === null || refunds === null) {
    return null;
  }

  const isDisabled = billingStatus === BillingStatus.Closed;

  return (
    <div className={styles.container}>
      <h3 className={styles.title}>{t("collectionPoint.billingPaymentSchedule.title")}</h3>
      {quarterlyPayments.length > 0 && (
        <>
          <div className={styles.paymentsList}>
            {quarterlyPayments.map((payment) => (
              <BillingPaymentQuarterCard
                key={payment.period}
                payment={payment}
                dueDate={paymentSchedule[`${payment.period}DueDate` as keyof typeof paymentSchedule]}
                isDisabled={isDisabled}
              />
            ))}
          </div>
          <BillingPaymentAnnualCard billing={billing} isTotal />
        </>
      )}
      {yearlyPayment && (
        <BillingPaymentAnnualCard
          billing={billing}
          payment={yearlyPayment}
          dueDate={paymentSchedule.annualDueDate}
          isDisabled={isDisabled}
        />
      )}
      {refunds.map((refund, index) => (
        <BillingRefundCard key={index} refund={refund} />
      ))}
    </div>
  );
};
